import type { SportsbookMeta } from '@/api/affiliateLinks'
import type { ComponentType, SVGProps } from 'react'
import Bet365Logo from '../assets/sportsbooks/bet365.svg?react'
import CaesarsLogo from '../assets/sportsbooks/caesars.svg?react'
import CoolbetLogo from '../assets/sportsbooks/coolbet.svg?react'
import DraftKingsLogo from '../assets/sportsbooks/draftkings.svg?react'
import { getApiBase } from '../lib/api-client'
import { resolveAssetUrl } from '../lib/assetUrl'

// SVG sportsbook logos are inlined into the widget bundle so they survive
// aggressive ad-blocker filter lists, which commonly match the
// /sportsbooks/<brand>.svg URL pattern. PNG/JPG/WebP logos stay URL-
// fetched — inlining them would balloon the bundle by ~250kB gzipped.
const INLINE_LOGOS: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  Bet365: Bet365Logo,
  Caesars: CaesarsLogo,
  Coolbet: CoolbetLogo,
  DraftKings: DraftKingsLogo,
}

export function logoSrc(meta: SportsbookMeta | undefined): string | undefined {
  return resolveAssetUrl(getApiBase(), meta?.logo_url)
}

export function hasLogo(sportsbook: string, meta: SportsbookMeta | undefined): boolean {
  return !!INLINE_LOGOS[sportsbook] || !!logoSrc(meta)
}

export function LogoMark({ sportsbook, meta, className }: {
  sportsbook: string
  meta: SportsbookMeta | undefined
  className: string
}) {
  const Inline = INLINE_LOGOS[sportsbook]
  if (Inline) return <Inline className={className} aria-label={sportsbook} role="img" />
  const src = logoSrc(meta)
  if (src) return <img src={src} alt={sportsbook} className={className} />
  return null
}
